import React, { useState, useMemo, useCallback, useEffect, useRef } from 'react';
import { NavLink, useLocation } from 'react-router-dom';
import { useSelector, useDispatch } from 'react-redux';
import { url, history } from '../../utils/variables';
import { getDirection, numToPrice, pexios, toast } from '../../utils/functions';
import { setLanguage, setLocation, setUser } from '../../redux/actions';
import ContactBox from './ContactBox';
import logo from '../../assets/images/logo.png';
import defaultProfile from '../../assets/images/default_profile.png';
import Modal from './Modal';
import { toast as toast2 } from 'react-toastify';
import RegisterStamp from '../../assets/images/approved.png';
import { useTranslation } from 'react-i18next';


export default function Header() {

    const [showOverlay, setShowOverlay] = useState(false);
    const [openMenu, setOpenMenu] = useState(false);

    const location = useLocation();

    const {user,language} = useSelector(store => store);

    const dispatch = useDispatch();
    ////
    const languageModal = useRef(null);
    const { t, i18n } = useTranslation();
    const [currentLanguage,setCurrentLanguage] = useState(i18n.language || language.lang);
    const [langModal,setLangModal] =useState(false)
    const [full_stars, setFullStars] = useState(user.data ? JSON.parse(user.data)?.starindex : -1);
    const expertLocation = useSelector(store => store.location);

    const openOverlay = useCallback(() => {
        setShowOverlay(true);
        setTimeout(() => setOpenMenu(true));
    }, []);
    const closeOverlay = useCallback(() => {
        setOpenMenu(false);
        setStarsInfo(false)
        setTimeout(() => setShowOverlay(false), 300);
    }, []);
    ////
    useEffect(() => {
        function handleClickOutside(event) {
            if (languageModal.current && !languageModal.current.contains(event.target)) {
                setLangModal(false);
            }
        }
        document.addEventListener('mousedown', handleClickOutside);
        return () => {
            document.removeEventListener('mousedown', handleClickOutside);
        };
    }, [language]);
    ////
    const [ firstLogin , setFirstLogin] = useState(false) 
    useEffect(()=>{
        currentLanguage && i18n.changeLanguage(currentLanguage);
        if(location.pathname === '/login' && firstLogin){
            setFirstLogin(false)
            return
        }
        if(firstLogin) return
        else if(location.pathname === '/' && Object.keys(user).length ){
            updateUser();
            setFirstLogin(true)
        }   
    
    },[location.pathname])

    ///
     const [ permission, setPermission] = useState(false);
    // const updateLocation = useCallback((latitude,longitude)=> {
    //     pexios("/api/update_location","post",{lat:latitude,lng:longitude, path:location.pathname})
    //             .then(()=>{
    //                 dispatch(setLocation({
    //                     lat: latitude,
    //                     lng: longitude,
    //                 }))
    //             })
    // },[])
    // useEffect(()=>{
    //     toast2.dismiss();
    //     let watchPosition
    //     let timer
    //     let preventSendLocation = false;
    //     //console.log("location")
    //     if((user.id === 55 || user.id === 89957) && firstLogin === true) {
    //         if(permission) {
    //             setPermission(false)
    //             return
    //         } 
    //         watchPosition = navigator.geolocation.watchPosition(position=>{
    //             if (preventSendLocation) return;
    //             preventSendLocation = true;
    //             setTimeout(() => preventSendLocation = false, 20000);
    //             // setTimeout(()=>setPermission(true),20000)
    //             updateLocation(position.coords.latitude,position.coords.longitude);
               
    //         },()=>{
    //              timer = setTimeout(()=>setPermission(true),20000)
    //             // navigator.permissions.query({name : "geolocation"})
    //             // .then((result)=>{
    //             //     if(result.state === "denied"){
    //             //         !permission && toast('لطفا برای دسترسی به موقعیت تنظیمات خود را مجددا بررسی کنید','error');
    //             //         //console.log("location")
    //             //     }
    //             // })
                  
    //             const pos ={ lat: 35.696747, lng: 51.378444 }
    //             !permission && updateLocation(pos.lat,pos.lng);
    //             // if (preventSendLocation) return;
    //             // preventSendLocation = true;
    //             // setTimeout(() => preventSendLocation = false, 20000);
    //             // if(!permission){
    //             //     timer = setTimeout(()=>setPermission(true),20000)
    //                  toast('لطفا برای دسترسی به موقعیت تنظیمات خود را مجددا بررسی کنید','error');
    //             // }
    //             //console.log("location")
    //         })
    //     }  
    //     return()=>{
    //         navigator.geolocation.clearWatch(watchPosition);
    //         clearTimeout(timer)
    //         // setPermission(false)
    //     }
    // },[firstLogin,updateLocation,permission,expertLocation])
    const sendLocation = useCallback((lat, lng) => {
        pexios('api/update_location', 'post', { lat, lng })
            .then(res => {
                // navigator.geolocation.watchPosition(()=>{
                //     if(user.id === 89957 )
                //         dispatch(setLocation({
                //             lat,
                //             lng,
                //             gpsAccept : 1
                //         }))
                // },()=>{
                //     if(user.id === 89957)
                //         dispatch(setLocation({
                //             lat,
                //             lng,
                //             gpsAccept : 0
                //         }))
                //         //console.log(res.data)
                // })
            });
    }, []);
    
    useEffect(() => {
        toast2.dismiss();
        let timer
        let preventSendLocation = false;
        let locationWatcher
        if(user.type === 'expert' && firstLogin === true){
        sendLocation(expertLocation.lat, expertLocation.lng);
        locationWatcher = navigator.geolocation.watchPosition(info => {
            if (preventSendLocation) return;
            preventSendLocation = true;
            setTimeout(() => preventSendLocation = false, 10000);
            sendLocation(info.coords.latitude, info.coords.longitude);
        },
        ()=>{
            //if(user.id !== 89957){
                timer = setTimeout(()=>setPermission(prevState=>!prevState),30000)
                 toast(t('To accessing your GPS check setting'),'error');
                pexios('api/off-gps'); 
           //}
        }
        );
       
    }
        return () => {
            if(user.type === 'expert'){
                navigator.geolocation.clearWatch(locationWatcher);
                clearTimeout(timer)
            }
        }
    }, [ sendLocation ,firstLogin,permission]);
    
    function updateUser() {
        pexios('api/v2/get_user')
            .then(res => {
                dispatch(setUser(res.data));
                user.type === 'expert' && setFullStars(JSON.parse(res.data.data).starindex > -1 ? JSON.parse(res.data.data).starindex : -1)
            });
    } 
    function exitApp() {
        dispatch(setUser({}));
        setFirstLogin(false)
        history.replace('/login');
    }

    useEffect(() => {
        if (location) closeOverlay();
    }, [closeOverlay, location])

    const hideNavBar = useMemo(() => {
        return [
            '/tutorial',
            '/login',
        ].includes(location.pathname);
    }, [location.pathname]);
    const disabledMenu = useMemo(() => {
        return [
            '/complete',
            '/waiting',
            '/expert-waiting',
            '/expert-map',
            '/culprit-detail',
            '/losses-detail',
            '/final-pricing',
            ...(!user.type ? ['/rules'] : []),
        ].includes(location.pathname);
    }, [location.pathname, user.type]);
    const disabledBack = useMemo(() => {
        return [
            '/',
            '/complete',
            '/waiting',
            '/expert-waiting',
            '/expert-map',
            '/culprit-detail',
            '/losses-detail',
            '/final-pricing',
        ].includes(location.pathname);
    }, [location.pathname]);

    const [ starsInfo,setStarsInfo] = useState(false)
    
    const Stars = useCallback(()=>{
        const stars = new Array(6)
        for(let i = 0 ; i < 6 ; i++){
            if(i <= full_stars)
                stars.push(<i className='fas fa-circle full-circle' key={i}/>)
            else 
                stars.push(<i className='fas fa-circle empty-circle' key={i}/>)
        }
        
        return stars
    },[full_stars])
    function changeExpertOnline (online) {
        toast2.dismiss();
        if(user.online !== online){
            navigator.permissions.query({name : "geolocation"})
            .then((result)=>{
                if(result.state === "denied" && online){
                    toast(t('Turn on your GPS access'),'error');
                    return
                }else{
                    pexios('/api/change_expert_online', 'post', { online: online })
                    .then(()=>{
                        dispatch(setUser({
                            ...user,
                            online : online
                        }))
                        online ? 
                        toast(`${user.full_name} ${t('Expert online alert')}`,'success',15000)
                        : toast(`${user.full_name} ${t('Expert offline alert')}`,'error',15000)
            
                    })
                }
            })
        }
    }
    function languageChange(lang) {
        setLangModal(false);
        i18n.changeLanguage(lang);
        dispatch(setLanguage({lang :lang}))
        setCurrentLanguage(lang);
        history.replace('/');
    }

    return (
        <>
            {langModal &&
                <div className='language-modal'>
                    <Modal visible={langModal}>
                        <div className='language-box' ref={languageModal} data-dir={getDirection(i18n.language)}>
                            <div className='language-option'>
                                <label htmlFor="fa">{t('Farsi')}</label>
                                <input id="fa" type="radio" name="language" onChange={()=>languageChange("fa")} checked={currentLanguage === "fa"}/>
                            </div>
                            <div className='language-option'>
                                <label htmlFor="en">{t('English')}</label>
                                <input id="en" type="radio" name="language" onChange={()=>languageChange("en")} checked={currentLanguage === "en"}/>
                            </div>
                            <div className='language-option'>
                                <label htmlFor="ar">{t('Arabic')}</label>
                                <input id="ar" type="radio" name="language" onChange={()=>languageChange("ar")} checked={currentLanguage === "ar"}/>
                            </div>
                            <div className='language-option'>
                                <label htmlFor="ru">{t('Russian')}</label>
                                <input id="ru" type="radio" name="language" onChange={()=>languageChange("ru")} checked={currentLanguage === "ru"}/>
                            </div>
                            <div className='language-option'>
                                <label htmlFor="tu">{t('Turkish')}</label>
                                <input id="tu" type="radio" name="language" onChange={()=>languageChange("tu")} checked={currentLanguage === "tu"}/>
                            </div>
                        </div>
                    </Modal>
                </div>
            }
            {
                !hideNavBar &&
                <div className='header' data-dir={getDirection(i18n.language)}>
                    <div className='menuBox'>
                        {
                            !disabledMenu && 
                            <button onClick={openOverlay}>
                                <i className='fas fa-bars' />
                            </button>
                        }
                    </div>
                    <div className='logoBox'>
                        <img src={logo} alt='logo' />
                    </div>
                    
                    
                    <div className='backBox'>
                        {/* {
                            !disabledBack &&
                            <button onClick={() => history.goBack()}>
                                <i className='fas fa-chevron-left' />
                            </button>
                        } */}
                        {
                            location.pathname === '/' &&
                                <ContactBox />
                        }
                    </div>
                </div>
            }
            
            
            {
                showOverlay &&
                <div className={openMenu ? 'side-bar-parent active' : 'side-bar-parent'} data-dir={getDirection(i18n.language)}>

                    {!disabledMenu &&
                        <div className={openMenu ? 'close-header active' :'close-header'}><i className={`fas fa-chevron-${getDirection(i18n.language) === 'rightToLeft'?'right':'left'} `} onClick={closeOverlay} /></div>
                    }

                     {/* {
            starsInfo && notifStep === 0 &&
                            <div className={`popUp-tuturial ${starsInfo ?'active':''}`}>
                                
                                <div className='stars-info'>
                                <div className='new-box'>
                                    {notifStep === 0 && <Stars />}
                                </div>
                                <div className='arrow-modal'/>
                                    <p>

                                    </p>
                                    <button className='btn  btn-green mt20 btn-circle' onClick={() => setStarsInfo(false)}>متوجه شدم</button>
                                    <button className='btn  btn-green mt20 btn-circle' onClick={() => setNotifStep(1)}> بعدی</button>
                                </div>
                            </div>
                            } */}
                    {/* <div className='overlay' />
                    <div className='outside' onClick={closeOverlay} /> */}
                    <div className='inside'>
                      
                    
                        {/* <div className='close-header'><i className='fas fa-chevron-right ' onClick={closeOverlay} /></div> */}
                            {user.type === 'expert'&& (
                                <div className={`expert-stars ${starsInfo ? '' : ''}`} onClick={() => setStarsInfo(true)}>
                                    <Stars />
                                </div>
                            )}
                            
                        <div className='side-bar'>
                            <div className='profile'>
                            <div className={`profile-info ${user.online ? 'active' : 'onActive'}`}>
                            <div className='text-center'>
                                <div className={ !user.online ?'image-parent grey-profile' : 'image-parent'} onClick={updateUser}>
                                <img
                                
                                        src={
                                            user.avatar ?
                                                `${url}/files?uid=${user.avatar.uid}&width=200&height=200` :
                                                defaultProfile
                                        }
                                        alt='profile'
                                    />
                                </div>
                            </div>
                            <h4 className='text-center'>{user.full_name}</h4>
                           </div>
                            {/* <ul>
                                <li><NavLink to='/edit-profile'><i className='fas fa-user' /> ویرایش پروفایل </NavLink></li>
                                {
                                    user.type === 'expert' &&
                                    <li><NavLink to='/wallet'><i className='fas fa-wallet' /> کیف پول دیجیتال </NavLink></li>
                                }
                                <li><NavLink to='/report-list'><i className='fas fa-car-crash' /> {` ${user.type === 'expert' ? 'کارشناسی' : 'پرونده'} های من`} </NavLink></li>
                                <li><NavLink to='/register-list'><i className='fas fa-stamp' /> لیست صدور </NavLink></li>
                                <li><NavLink to='/register'><i className='fas fa-file' /> صدور بیمه نامه بدنه </NavLink></li>
                                <li><NavLink to='/about'><i className='fas fa-phone' /> تماس با ما </NavLink></li>
                                <li><NavLink to='/rules'><i className='fas fa-list' /> شرایط و قوانین </NavLink></li>
                                <li className='logout' onClick={exitApp}><i className='fas fa-power-off' /> خروج </li>
                            </ul> */}
                            
                            <ul>
                            <div className='inside-header'>
                                {user.type !== 'expert' &&
                                <div className='d-flex flex-column box-header' style={{border: '2px solid rgb(29, 209, 161)'}}>
                                        <div className='p5' style={{fontSize: '14px'}}>
                                            <i className='fas fa-wallet'/> 
                                            {t('Balance of digital wallet')}:
                                            <span style={user.my_wallet?.total_left < 0 ? {color: 'red'} : {}}> {numToPrice(user.my_wallet?.total_left || 0)} {t('rial')} </span>
                                            <div className='payment-btn mt10'>
                                            <button className='btn btn-green btn-circle' onClick={()=>history.replace('/payment')}><i className='fas fa-plus pl5' style={{color : 'white',fontSize: '12px'}}/>{t('Inventory increase')}</button>
                                            </div>
                                            </div>
                                </div>
                                        }
                                <div className='d-flex flex-column box-header'>
                                <NavLink to='/edit-profile'><i className='fas fa-user' /> {t('personal info edit')}</NavLink>
                                
                                <NavLink to='/wallet'><i className='fas fa-wallet' /> {t('digital wallet')}</NavLink>
                                
                                </div>
                                <div className='d-flex flex-column box-header'>
                                    <NavLink to='/report-list'><i className='fas fa-car-crash' /> {` ${user.type === 'expert' ? t('my process') : t('my files')} `} </NavLink>
                                    <NavLink to='/register-list'>  <i><img className='register-icon' src={RegisterStamp} style={{width : '23px'}}/></i> {t('my issued visit')}</NavLink>
                                {
                                    user.type !== 'expert' &&
                                    <NavLink to='/register'><i className='fas fa-stamp' />  {t('Visiting the issuance of body insurance policy')}</NavLink>
                                }
                                </div>
                                <div className='d-flex flex-column box-header'>
                                    {user.type === 'expert' && 
                                    <div className='d-flex btn-group mb10 mt10'>
                                        <button className={`btn btn-block btn-circle-right ${user.online ? 'active' :''}`} onClick={()=>changeExpertOnline(1)}>
                                            <i className='fas fa-user-check' /> {t('Ready work')}  
                                        
                                    </button>
                                        <button className={`btn btn-block btn-circle-left ${!user.online ? 'onActive' :''}`}  onClick={()=>changeExpertOnline(0)}>
                                            
                                            <i className='fas fa-user-times' />{t('I am on leave')}  
                                    </button>
                                    </div>
                                    }
                                    
                                    <NavLink to='/rules'> <i className='fas fa-gavel' /> {t('Terms and rules')}</NavLink>
                                    {(user.id === 89957 || user.id === 14 || user.id === 55) &&
                                        <li onClick={()=>setLangModal(true)}>
                                            <i className='fas fa-globe'>
                                            </i> {t('Language')} {currentLanguage !== 'en' && '/ Language'} 
                                        </li>
                                    }
                                    <NavLink to='/about'><i className='fas fa-phone' /> {t('Contact')}</NavLink>          
                                    {user.type === 'expert' &&<a href='https://www.hamrahac.com/go2panel' target="_blank" rel="noreferrer"><i className='fas fa-laptop' /> {t('Login to panel')}</a> }
                                                                     

                                    {user.type === 'expert' && 
                                    <a href={`https://www.hamrahac.com/education/${user.id}/${user.mobile}`} target="_blank" rel="noreferrer"><i className='fas fa-graduation-cap' /> {t('Education')} </a>
                                    }
                                    <li className='logout' onClick={exitApp}><i className='fas fa-power-off' /> {t('Logout')} </li>
                                </div>
                            </div>
                            </ul>
                            </div>
                            </div>
                            
                        </div>
                    </div>
            }
        </>
    )
}
